let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5wUQd")).then(() => parcelRequire('4s9GW'));